import { OrgNode } from './interfaces';
import { orgsRequest } from './request';

const GET_ORG_NODE_QUERY = `
query Org($orgId: ID!) {
    orgResponse: org(id: $orgId) {
      id
      name
      type
      fields
      parent {
        createdAt
        fields
        id
        name
        type
        updatedAt
      }
    }
  }
`;

export const getOrgNode = async (
  orgId: string,
): Promise<OrgNode | undefined> => {
  const orgNodeRes = await orgsRequest(GET_ORG_NODE_QUERY, {
    orgId,
  });
  const orgNodeResJson = await orgNodeRes.json();
  if (
    orgNodeResJson.data.orgResponse &&
    orgNodeResJson.data.orgResponse.length > 0
  ) {
    return orgNodeResJson.data.orgResponse[0];
  } else {
    return;
  }
};
